import type React from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

const GOOGLE_PLAY_URL =
	'https://play.google.com/store/apps/details?id=org.change.android&utm_source=internal&utm_medium=display_banner&utm_campaign=live_updates_on_the_go&utm_content=button&referrer=utm_source%3Dinternal%26utm_medium%3Ddisplay_banner%26utm_campaign%3Dlive_updates_on_the_go%26utm_content%3Dbutton';

export const Content: React.FC<{ onClickDownload: () => void }> = ({ onClickDownload }) => {
	const { translate } = useI18n();
	return (
		<Flex sx={{ flexDirection: 'column', gap: 8, minWidth: 100, flexGrow: 1 }}>
			<Box>
				<Text fontWeight="bold" sx={{ fontSize: 16 }}>
					<Translate value="corgi.app_download.bottom_banner.mobile.headline" />
				</Text>
			</Box>
			<Text sx={{ fontSize: 14 }}>
				<Translate value="corgi.app_download.bottom_banner.mobile.description" />
			</Text>
			<Box sx={{ marginTop: 8, marginBottom: 8 }}>
				<Link to={GOOGLE_PLAY_URL} target="_blank" onClick={onClickDownload}>
					<Image
						src="https://static.change.org/images/google-play-get-it-on-badge-EN-black.svg"
						alt={translate('corgi.app_download.bottom_banner.download_on_google_app_store.image_alt_text')}
						sx={{ minWidth: 180, width: 180 }}
					/>
				</Link>
			</Box>
		</Flex>
	);
};
